// web/src/helpers/formatSuccessToast.ts
//
// Web renders the shared {title, subtitle} success copy (owned by the common
// feature constants) as a single Ant `message.success` line. Mobile shows the
// same pair through a SuccessBottomSheet (title + subtitle); on web the toast is
// a single line, so we surface just the subtitle — the title is redundant in
// that compact form.

export interface SuccessMessage {
  title: string
  subtitle: string
}

export const formatSuccessToast = ({ subtitle }: SuccessMessage): string =>
  subtitle
